import { isBoolean } from "presentation/utils/functions/generic";

// StatusIndications methods
// Carrega um item no state
export const loadStatusIndication = (key, component) => {
    const { statusIndications } = component.state;
    let output = undefined;

    if (statusIndications.length > 0) {
        var item = statusIndications.find(x => { return x.key == key });
        output = item !== undefined ? item : undefined;
    }
    return output;
}

// Monta a lista no state
export const mountStatusIndicationItems = (component) => {

    const { totalStatusIndicationItems, statusIndications } = component.state;

    const deleteRequested = statusIndications.filter(x => x.isDeleteRequested === true);

    let newStatusIndications = [];

    for (let i = 0; i < totalStatusIndicationItems; i++) {

        let itemKey = i + 1;

        //Default values

        let defaultItemId = null;
        let defaultEvaluationPeriodId = null;
        let defaultName = undefined;
        let defaultFormula = undefined;

        let newItem = {
            key: itemKey,
            id: defaultItemId,
            evaluationPeriodId: defaultEvaluationPeriodId,
            name: defaultName,
            formula: defaultFormula
        };


        let statusIndication = loadStatusIndication(itemKey, component);

        if (statusIndication !== undefined) {
            newItem = { ...statusIndication };
        }

        newStatusIndications.push(newItem);
    }

    let finalStatusIndications = [...newStatusIndications, ...deleteRequested];

    component.setState({ statusIndications: finalStatusIndications });
}

//Carrega as informações de um campo específico do item no state
export const statusIndicationsFormValue = (key, formField, component) => {

    let output = undefined;

    var item = loadStatusIndication(key, component);

    output = item !== undefined ? item[formField] : undefined;

    return output;

}

//Tratativas para quando um campo muda de valor (geral)
export const handleChangeStatusIndications = (key, event, component) => {
    const { value, checked, type } = event.target;

    const name = event.target.getAttribute('data-field-name');
    const isTrueUnique = (event.target.getAttribute('data-field-is-true-unique') === "true");
    const changeValue = type == "checkbox" ? checked : value;

    handleFieldChange(key, name, changeValue, component, isTrueUnique);
}


//Método genérico para acompanhar tratativas de mudança de valor dos campos
export const handleFieldChange = (key, field, value, component, isTrueUnique = false) => {
    var item = loadStatusIndication(key, component);

    item = { ...item, [field]: value };

    const newStatusIndications = changeStatusIndicationsList(component, item);

    let finalOptions = beforeChangeStatusIndicationsState(key, field, value, newStatusIndications, component, isTrueUnique);

    component.setState({
        statusIndications: finalOptions
    });
}

//Método para executar tratamentos antes da mudança para o novo state do formulário
export const beforeChangeStatusIndicationsState = (key, changedField, changeValue, newStatusIndications, component, isTrueUnique = false) => {


    let output = newStatusIndications.map((le, i) => {
        if (!le.id) {
            let tempId = generateStatusIndicationVirtualId();
            le.id = tempId;
            le.tempId = tempId;
            le.isVirtualId = true;
        }
        return le;
    });
    //Apenas um item desse tipo de campo pode ser true
    if (isTrueUnique == true && isBoolean(changeValue) && changeValue === true) {
        output = newStatusIndications.map((e, i) => {
            if (e.key !== key) {
                e[changedField] = false;
            }
            return e;
        });
    }



    return output;
}

export const generateStatusIndicationVirtualId = () => {
    return `temp-status-indication-${new Date().getTime()}`;
}

//Prapara o objeto do state para a atualização com as informações das alternativas da questão
export const changeStatusIndicationsList = (component, targetOption, remove = false) => {
    let { statusIndications } = component.state;

    let optionIndex = statusIndications.findIndex(option => option.key == targetOption.key);

    if (remove === true) {
        let elementId = statusIndications[optionIndex]['id'] || undefined;
        let isVirtualId = statusIndications[optionIndex]['isVirtualId'] || false;

        let isApiDeleteRequired = isVirtualId ? false : (elementId ? true : false);

        if (isApiDeleteRequired) {
            statusIndications[optionIndex]['isDeleteRequested'] = true;
            statusIndications[optionIndex]['key'] = 'delete-requested-' + new Date().getTime();
        } else {
            statusIndications.splice(optionIndex, 1);
        }
    } else {
        statusIndications[optionIndex] = targetOption;
    }

    return statusIndications;
}


const statusIndicationsFunctions = {
    loadStatusIndication,
    statusIndicationsFormValue,
    handleChangeStatusIndications,
    beforeChangeStatusIndicationsState,
    changeStatusIndicationsList,
    mountStatusIndicationItems,
    generateStatusIndicationVirtualId
}

export default statusIndicationsFunctions;